import * as Reducers from './audio-video-connection-monitor.reducers';
import * as MetaReducers from './audio-video-connection-monitor.metareducer';

export const AudioVideoConnectionMonitorReducers = { Reducers,  MetaReducers };
